import React from 'react';
import {
    NButton,
    NRadio,
    NRadioGroup,
    NTooltip,
} from '@innersource-nn/novoui-react';
import { DatasetCreateFormData, defaultCreateValues } from 'types/Forms';
interface ThirdStepProps {
    importing: boolean;
    setImporting: React.Dispatch<React.SetStateAction<boolean>>;
    formData: DatasetCreateFormData;
    setFormData: React.Dispatch<React.SetStateAction<DatasetCreateFormData>>;
    handleNext(index: number): void;
}

export default function FirstStep({
    importing,
    setImporting,
    setFormData,
    handleNext,
}: ThirdStepProps) {
    function handleClick() {
        if (importing) {
            setFormData({
                ...defaultCreateValues,
                bucketName: '',
                topics: [],
            });
        } else {
            setFormData({
                ...defaultCreateValues,
                datasetStageOptions: 'PROD',
                enableCrawler: true,
            });
        }
        handleNext(0);
    }

    return (
        <div>
            <NRadioGroup
                direction="column"
                onChange={(value) => setImporting(value === 'import')}
                style={{
                    columnGap: 8,
                }}
                value={importing ? 'import' : 'create'}
                variant="fill"
            >
                <NRadio value="create">Creating new dataset</NRadio>
                <NRadio value="import">
                    <div className="flex items-center gap-16">
                        Importing existing one from another AWS account
                        <NTooltip
                            iconSize="small"
                            content="By linking an existing dataset in another AWS account it allows you to integrate its data with your new dataset. "
                            placement="up"
                        />
                    </div>
                </NRadio>
            </NRadioGroup>
            <NButton
                variant="fill"
                square
                className="bg-sea-blue-600 mt-8"
                onClick={handleClick}
            >
                Next step
            </NButton>
        </div>
    );
}
